var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('leaflet-basic'),_c('leaflet-marker-circle-polygon'),_c('leaflet-popup'),_c('leaflet-geo-jSON'),_c('leaflet-group'),_c('leaflet-custom-icon')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }